/* eslint-disable */
export default {
  conferenceCall: '電話會議',
  onHold: '保留',
  ongoing: '進行中',
  unknown: '未知',
  disconnected: '已中斷連線',
  loading: '正在載入...',
  loadingTimeout: '載入逾時。',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
